import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { AlertCircle } from 'lucide-react';

/**
 * Reusable info/help card component
 * Used for: Tips, warnings, how-to guides, feature explanations
 * Variants: info (blue), success (green), warning (yellow), danger (red)
 */
const InfoCard = ({ 
  icon: Icon = AlertCircle,
  title, 
  children,
  variant = 'info', // info, success, warning, danger
  showIcon = true,
  className = ''
}) => {
  const variants = {
    info: {
      bg: 'bg-blue-50',
      border: 'border-blue-200',
      iconColor: 'text-blue-600',
      titleColor: 'text-blue-900',
      textColor: 'text-blue-800'
    },
    success: {
      bg: 'bg-green-50',
      border: 'border-green-200',
      iconColor: 'text-green-600',
      titleColor: 'text-green-900',
      textColor: 'text-green-800'
    },
    warning: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-200',
      iconColor: 'text-yellow-600',
      titleColor: 'text-yellow-900',
      textColor: 'text-yellow-800'
    },
    danger: {
      bg: 'bg-red-50',
      border: 'border-red-200',
      iconColor: 'text-red-600',
      titleColor: 'text-red-900',
      textColor: 'text-red-800'
    }
  };

  const styles = variants[variant] || variants.info;

  return (
    <Card className={`${styles.bg} ${styles.border} ${className}`}>
      <CardContent className="pt-6">
        <div className="flex items-start gap-3">
          {showIcon && Icon && (
            <Icon className={`w-5 h-5 ${styles.iconColor} flex-shrink-0 mt-0.5`} />
          )}
          <div className="flex-1">
            {title && (
              <h3 className={`font-semibold ${styles.titleColor} mb-2`}>{title}</h3>
            )}
            <div className={`text-sm ${styles.textColor}`}>
              {children}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default InfoCard;
